<template>
<div class="modal-card" style="width: auto; min-width:640px">
  <header class="modal-card-head">
    <p class="modal-card-title">{{editEnabled ? "Edit Cluster" : "Add Cluster"}}</p>
  </header>
  <section class="modal-card-body">
    <b-field label="Cluster Name:">
      <b-input :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="text" v-model="name" placeholder="Cluster Name"></b-input>
    </b-field>
    <b-field v-if="bNameError" style="color: red">
      Please enter a name.
    </b-field>
    <b-field label="Main Playlist:">
      <b-select :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="mainPlaylistId">
        <option value="">---None---</option>
        <option v-for="(playlist, id) in playlists" :key="id" :value="id">{{playlist.name}}</option>
      </b-select>
    </b-field>
    <b-field v-if="bMainError" style="color: red">
      Please choose main playlist.
    </b-field>
    <b-field v-if="campaignsAddOn" label="Campaigns:">

      <b-table :mobile-cards="false" :data="clusterCampaigns.length > 0 ? clusterCampaigns : []" bordered :class="{ mytable: clusterCampaigns.length > 3 }">

        <template slot-scope="props">
          <b-table-column field="campaignName" label="Name" centered class="topPadding">
            {{getCampaignName(props.row.name)}}
          </b-table-column>
          <b-table-column field="playlistId" label="Playlist" centered class="topPadding">
            {{getPlaylistName(props.row.playlistId)}}
          </b-table-column>
          <b-table-column field="campaignType" label="Type" centered class="topPadding">
            {{getType(props.row.type)}}
          </b-table-column>
          <b-table-column field="dateRange" label="Date range" centered>
            {{props.row.startDate}}<br>{{props.row.endDate}}
          </b-table-column>
          <b-table-column field="timeRange" label="Time range" centered>
            {{props.row.startTime}}<br>{{props.row.endTime}}
          </b-table-column>
          <b-table-column label="Edit/Delete" centered class="topPadding">
            <b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="is-info" icon-left="edit" size="is-small" @click="editCampaignModal(props.index, props.row.id)"></b-button>
            <b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="is-danger" icon-left="trash" size="is-small" @click="confirmRemoveCampaign(props.row.id, props.row.name, props.index)"></b-button>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>No campaigns yet.</p>
            </div>
          </section>
        </template>
      </b-table>
    </b-field>
    <b-field v-if="overlap" style="color: red">
      There is overlapping between your campaigns.
    </b-field>
      <b-button v-if="campaignsAddOn" :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="is-success" icon-left="plus" @click="addCampaignModal">Add campaign</b-button>
    <v-divider></v-divider>
    <b-field label="Current Devices:">
    </b-field>
    <div :class="{ scrollit: devicesLength(currentDevices) }">
      <table>
  <tr v-for="(device, id) in currentDevices" :key="id">
    <td width="100%">{{device.name}}</td>
    <td><b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" icon-left="times" size="is-small" type="is-danger" @click="removeDeviceFromCurrent(id, device)"></b-button></td>
  </tr>
</table>
</div>

    <v-divider></v-divider>
    <b-field label="Available Devices:"></b-field>
    <div :class="{ scrollit: devicesLength(availableDevices) }">
    <table>
  <tr v-for="(device, id) in availableDevices" :key="id">
    <td width="100%">{{device.name}}</td>
    <td><b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" icon-left="plus" size="is-small" type="is-success" @click="addDeviceToCurrent(id, device)"></b-button></td>
  </tr>
</table>
</div>
    <v-divider></v-divider>
    <div class="field">
      <b-switch :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="bHasMenu">Menu?</b-switch>
      <b-select :disabled="role !== 'admin' && role !== 'device' && isMigrated" id="menuId" v-model="menuId" v-if="bHasMenu">
        <option value="">---None---</option>
        <option v-for="(menu, id) in menus" :key="id" :value="id">{{menu.name}}</option>
      </b-select>
      <b-field v-if="bMenuError" style="color: red">
        Please choose a menu.
      </b-field>
    </div>
    <div class="field">
      <b-switch :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="bHasSpecialOffer">Special Offers?</b-switch>
      <b-select :disabled="role !== 'admin' && role !== 'device' && isMigrated" id="specialOffersMenuId" v-model="specialOffersMenuId" v-if="bHasSpecialOffer">
        <option value="">---None---</option>
        <option v-for="(offer, id) in specialOffers" :key="id" :value="id">{{offer.name}}</option>
      </b-select>
      <b-field v-if="bSOError" style="color: red">
        Please choose a special offers menu.
      </b-field>
    </div>
      <div class="field mt-3">
      <b-switch v-if="documentsAddOn" :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="bHasDocuments">Documents?</b-switch>
    </div>
      <div class="field mt-3">
      <b-switch v-if="customerSatisfactionAddOn" :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="bHasCustomerSatisfaction">Customer satisfaction?</b-switch>
    </div>
    <div class="field mt-3">
      <b-switch v-if="appMenuAddOn" :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="bHasAppMenu">App menu?</b-switch>
    </div>
    <div v-if="questionnairesAddOn" class="field mt-3">
      <b-switch :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="bHasQuestionnaires">Questionnaires?</b-switch>
      <b-select :disabled="role !== 'admin' && role !== 'device' && isMigrated" id="questionnaireId" v-model="questionnaireId" v-if="bHasQuestionnaires">
        <option value="">---None---</option>
        <option v-for="(q, id) in questionnaires" :key="id" :value="id">{{q.name}}</option>
      </b-select>
      <b-field v-if="bQTNRError" style="color: red">
        Please choose a questionnaire.
      </b-field>
    </div>
    <b-switch :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="bHasMovingText">Moving text?</b-switch>
    <b-input :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="text" id="movingText" placeholder="Write moving text here..." v-model="movingText" v-if="bHasMovingText"></b-input>
    <b-field v-if="bMTError" style="color: red">
        Please enter moving text.
      </b-field>
  </section>
  <footer class="modal-card-foot">
    <b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="is-info" @click="editCluster" v-if="editEnabled">Submit</b-button>
    <b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="is-info" @click="addCluster" v-else>Add new cluster</b-button>
    <b-button type="is-light" @click="closeModal()">Cancel</b-button>
  </footer>
</div>
</template>

<script>
import CampaignAddEdit from '@/components/clusters/campaigns/CampaignAddEdit'
export default {
  name: 'ClusterAddEdit',
  props: ['editEnabled', 'propId', 'propParentFn'],
  data: () => {
    return {
      editStaticClusterRef: {},
      name: '',
      mainPlaylistId: '',
      bHasMenu: false,
      menuId: '',
      bHasSpecialOffer: false,
      specialOffersMenuId: '',
      questionnaireId: '',
      bHasMovingText: false,
      movingText: '',
      currentDevices: {},
      availableDevices: {},
      bNameError: false,
      bMainError: false,
      bMenuError: false,
      bSOError: false,
      bMTError: false,
      bQTNRError: false,
      loadingComponent: null,
      clusterCampaigns: [],
      campaignsToDelete: [],
      newCampaigns: [],
      campaignsToEdit: [],
      campaignsAddOn: false,
      customerSatisfactionAddOn: false,
      documentsAddOn: false,
      questionnairesAddOn: false,
      appMenuAddOn: false,
      overlap: false,
      jsonResp: null,
      campaignsChange: false,
      clusterCampaignsOld: [],
      clusterOld: null,
      currentDevicesOld: {},
      bHasCustomerSatisfaction: false,
      bHasDocuments: false,
      bHasQuestionnaires: false,
      bHasAppMenu: false
    }
  },
  computed: {
    playlists () {
      return this.$store.state.playlists
    },
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    campaigns () {
      return this.$store.state.campaigns
    },
    questionnaires () {
      return this.$store.state.questionnaires
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    },
    isMigrated () {
      return !this.getNotMigrated().includes(this.$store.state.uid)
    }
  },
  created: function () {
    fetch('https://api.seeip.org/geoip').then(
      (response) => response.json()
    ).then(
      (jsonResponse) => {
        this.jsonResp = jsonResponse
        this.globalLogger(this.jsonResp)
      }
    )
    let unassignedDevicesRef = this.$store.getters.getUnassignedDevices
    for (let device in unassignedDevicesRef) {
      this.availableDevices[device] = unassignedDevicesRef[device]
    }
  },
  mounted: function () {
    this.globalLogger('USER ID', this.userId)
    if (this.$store.state.addOns !== null) {
      if (this.$store.state.addOns.campaigns === true) {
        this.campaignsAddOn = true
      }
      if (this.$store.state.addOns.customerSatisfaction === true) {
        this.customerSatisfactionAddOn = true
      }
      if (this.$store.state.addOns.documents === true) {
        this.documentsAddOn = true
      }
      if (this.$store.state.addOns.questionnaires === true) {
        this.questionnairesAddOn = true
      }
      if (this.$store.state.addOns.appMenu === true) {
        this.appMenuAddOn = true
      }
    }
    if (this.editEnabled) {
      this.editStaticClusterRef = Object.assign({}, this.$store.getters.getCluster(this.propId))
      this.clusterOld = Object.assign({}, this.editStaticClusterRef)
      this.name = this.editStaticClusterRef['name']
      this.mainPlaylistId = this.editStaticClusterRef['mainPlaylistId'] || ''
      this.extendedPlaylistId = this.editStaticClusterRef['extendedPlaylistId']
      this.bHasMenu = this.editStaticClusterRef['menuId'].length > 0
      this.menuId = this.editStaticClusterRef['menuId']
      this.bHasSpecialOffer = this.editStaticClusterRef['specialOffersMenuId'].length > 0
      this.specialOffersMenuId = this.editStaticClusterRef['specialOffersMenuId']
      this.bHasMovingText = this.editStaticClusterRef['movingText'].length > 0
      this.movingText = this.editStaticClusterRef['movingText']
      this.bHasCustomerSatisfaction = this.editStaticClusterRef['customerSatisfaction'] || false
      this.bHasDocuments = this.editStaticClusterRef['documents'] || false
      this.bHasAppMenu = this.editStaticClusterRef['appMenuEnabled'] || false
      if (this.editStaticClusterRef['questionnaireId'] !== undefined) {
        this.bHasQuestionnaires = this.editStaticClusterRef['questionnaireId'].length > 0
        this.questionnaireId = this.editStaticClusterRef['questionnaireId']
      } else {
        this.bHasQuestionnaires = false
        this.questionnaireId = ''
      }

      let currentDevicesRef = this.$store.getters.getDevicesForCluster(this.propId)
      for (let device in currentDevicesRef) {
        this.currentDevices[device] = currentDevicesRef[device]
      }
      this.currentDevicesOld = Object.assign({}, this.currentDevices)
      this.globalLogger('heeere')
      this.globalLogger(this.currentDevicesOld, this.currentDevices)

      let unassignedDevicesRef = this.$store.getters.getUnassignedDevices
      for (let device in unassignedDevicesRef) {
        this.availableDevices[device] = unassignedDevicesRef[device]
      }

      /* for (let cluster in this.campaigns) {
        this.globalLogger(cluster)
      } */
      if (this.campaignsAddOn) {
        if (this.campaigns !== null) {
          const keys = Object.keys(this.campaigns)
          keys.forEach((key, index) => {
            if (key === this.propId) {
              this.globalLogger(key, this.campaigns[key]) // cluster
              let cl = this.campaigns[key]
              // this.cluterCampaigns = cl
              const newKeys = Object.keys(this.campaigns[key])
              newKeys.forEach((newKey, newIndex) => {
                this.globalLogger(newKey, cl[newKey])
                this.clusterCampaigns.push({ id: newKey, ...cl[newKey] })
              })
            }
          })
          this.globalLogger(this.clusterCampaigns, 'cl camp')
          this.clusterCampaignsOld = Object.assign({}, this.clusterCampaigns)
          // let addOns = this.$store.state.addOns
        }
      }
    }
  },
  watch: {
    bHasMenu () {
      if (this.bHasMenu === false) {
        this.bMenuError = false
      }
    },
    bHasSpecialOffer () {
      if (this.bHasSpecialOffer === false) {
        this.bSOError = false
      }
    },
    bHasMovingText () {
      if (this.bHasMovingText === false) {
        this.bMTError = false
      }
    }
  },
  methods: {
    addCluster () {
      this.bNameError = false
      this.bMainError = false
      this.bMenuError = false
      this.bSOError = false
      this.bMTError = false
      this.bQTNRError = false
      this.overlap = false
      if (this.name === '') {
        this.bNameError = true
      } else if (this.mainPlaylistId === '') {
        this.bMainError = true
      } else if (this.bHasMenu === true && this.menuId === '') {
        this.bMenuError = true
      } else if (this.bHasSpecialOffer === true && this.specialOffersMenuId === '') {
        this.bSOError = true
      } else if (this.bHasQuestionnaires === true && this.questionnaireId === '') {
        this.bQTNRError = true
      } else if (this.bHasMovingText === true && this.movingText === '') {
        this.bMTError = true
      } else if (this.campaignsAddOn && this.checkOverlap()) {
        this.overlap = true
        this.globalLogger('OVERLAP', this.overlap)
      } else {
        this.loadingComponent = this.$buefy.loading.open()
        let newClusterRef = null
        if (!this.getNotMigrated().includes(this.userId)) {
          newClusterRef = this.$store.state.database.ref('/neoslide/clusters/' + this.workspaceId).push()
        } else {
          newClusterRef = this.$store.state.database.ref('/clusters/' + this.userId).push()
        }

        newClusterRef.set({
          name: this.name,
          id: newClusterRef['key'],
          mainPlaylistId: this.mainPlaylistId || '',
          extendedPlaylistId: '',
          movingText: this.movingText || '',
          menuId: this.menuId || '',
          specialOffersMenuId: this.specialOffersMenuId || '',
          userId: this.$store.state.uid,
          customerSatisfaction: this.bHasCustomerSatisfaction,
          documents: this.bHasDocuments,
          questionnaireId: this.questionnaireId || '',
          appMenuEnabled: this.bHasAppMenu
        }, () => {
          var clLog = {
            ip_addr: this.jsonResp ? this.jsonResp.ip : '',
            city: this.jsonResp ? this.jsonResp.city : '',
            clusterName: this.name,
            mainPlaylistId: this.mainPlaylistId,
            clusterId: newClusterRef['key'],
            movingText: this.movingText,
            menuId: this.menuId,
            specialOffersMenuId: this.specialOffersMenuId,
            userId: this.$store.state.uid
          }
          var currentDevicesList = []
          for (let dev in this.currentDevices) {
            currentDevicesList.push(this.currentDevices[dev].name + ' | ' + dev)
          }
          clLog.currentDevicesList = currentDevicesList
          this.globalLogger(clLog, 'cl llog')
          if (this.campaignsAddOn === true) {
            var campaignsList = []
            for (let campaign in this.clusterCampaigns) {
              var c = this.clusterCampaigns[campaign]
              campaignsList.push(c.name + ' | ' + c.type + ' | ' + c.startDate + ' - ' + c.endDate + ' | ' + c.startTime + ' - ' + c.endTime)
            }
            clLog.campaignsList = campaignsList
            this.globalLogger(campaignsList, 'listtt')
          }
          this.$analytics.logEvent('add_cluster', clLog)
          this.closeModal()
          this.loadingComponent.close()
        })

        if (!this.getNotMigrated().includes(this.userId)) {
          for (let device in this.currentDevices) {
            this.$store.state.database.ref('/neoslide/devices/' + this.workspaceId + '/' + device).update({
              clusterId: newClusterRef['key']
            })
          }
        } else {
          for (let device in this.currentDevices) {
            this.$store.state.database.ref('/devices/' + this.userId + '/' + device).update({
              clusterId: newClusterRef['key']
            })
          }
        }

        if (this.campaignsAddOn) {
          if (this.newCampaigns.length > 0) {
            for (let j = 0; j < this.newCampaigns.length; j++) {
              let newCampaignRef = null
              if (!this.getNotMigrated().includes(this.userId)) {
                newCampaignRef = this.$store.state.database.ref('/neoslide/campaigns/' + this.workspaceId + '/' + newClusterRef.key).push()
              } else {
                newCampaignRef = this.$store.state.database.ref('/campaigns/' + this.userId + '/' + newClusterRef.key).push()
              }
              let campKey = newCampaignRef.key
              newCampaignRef.set({
                name: this.newCampaigns[j].name,
                playlistId: this.newCampaigns[j].playlistId,
                type: this.newCampaigns[j].type,
                startTime: this.newCampaigns[j].startTime,
                endTime: this.newCampaigns[j].endTime,
                startDate: this.newCampaigns[j].startDate,
                endDate: this.newCampaigns[j].endDate,
                id: campKey
              }, () => {
                this.globalLogger('done')
              })
            }
          }
        }
      }
    },
    editCluster () {
      this.bNameError = false
      this.bMainError = false
      this.bMenuError = false
      this.bSOError = false
      this.bMTError = false
      this.bQTNRError = false
      this.overlap = false
      if (this.name === '') {
        this.bNameError = true
      } else if (this.mainPlaylistId === '') {
        this.bMainError = true
      } else if (this.bHasMenu === true && this.menuId === '') {
        this.bMenuError = true
      } else if (this.bHasSpecialOffer === true && this.specialOffersMenuId === '') {
        this.bSOError = true
      } else if (this.bHasQuestionnaires === true && this.questionnaireId === '') {
        this.bQTNRError = true
      } else if (this.bHasMovingText === true && this.movingText === '') {
        this.bMTError = true
      } else if (this.campaignsAddOn && this.checkOverlap()) {
        this.overlap = true
        this.globalLogger('OVERLPAP', this.overlap)
      } else {
        /* if (this.campaignsAddOn) {
          if (this.clusterCampaignsOld.length === this.clusterCampaigns.length) {
            for (let i = 0; i < this.clusterCampaigns.length; i++) {
              if (this.clusterCampaignsOld[i] !== this.clusterCampaigns[i]) {
                this.campaignsChange = true
              }
            }
          } else {
            this.campaignsChange = true
          }
        }
        if (this.campaignsChange) {
          this.globalLogger(this.campaignsChange, 'change')
        } */
        // logiranje
        var clLog = {
          ip_addr: this.jsonResp ? this.jsonResp.ip : '',
          city: this.jsonResp ? this.jsonResp.city : ''
        }
        if (this.clusterOld.name !== this.name) {
          clLog.clusterOldName = this.clusterOld.name
          clLog.clusterNewName = this.name
        }
        if (this.clusterOld.mainPlaylistId !== this.mainPlaylistId) {
          clLog.oldPlaylistId = this.clusterOld.mainPlaylistId
          clLog.newPlaylistId = this.mainPlaylistId
        }
        if (this.clusterOld.menuId !== this.menuId) {
          clLog.oldMenuId = this.clusterOld.menuId
          clLog.newMenuId = this.menuId
        } else if (this.clusterOld.menuId !== '' && this.bHasMenu === false) {
          clLog.oldMenuId = this.clusterOld.menuId
          clLog.newMenuId = ''
        }
        if (this.clusterOld.specialOffersMenuId !== this.specialOffersMenuId) {
          clLog.oldSpecialOffersMenuId = this.clusterOld.specialOffersMenuId
          clLog.newSpecialOffersMenuId = this.specialOffersMenuId
        } else if (this.clusterOld.specialOffersMenuId !== '' && this.bHasSpecialOffer === false) {
          clLog.oldSpecialOffersMenuId = this.clusterOld.specialOffersMenuId
          clLog.newSpecialOffersMenuId = ''
        }
        if (this.clusterOld.movingText !== this.movingText) {
          clLog.oldMovingText = this.clusterOld.movingText
          clLog.newMovingText = this.movingText
        } else if (this.clusterOld.movingText !== '' && this.bHasMovingText === false) {
          clLog.oldMovingText = this.clusterOld.movingText
          clLog.newMovingText = ''
        }
        var currentDevicesListOld = []
        for (let oldDev in this.currentDevicesOld) {
          currentDevicesListOld.push(this.currentDevicesOld[oldDev].name + ' | ' + oldDev)
        }
        this.globalLogger(currentDevicesListOld, 'LIST OLD DEVICES')
        clLog.currentDevicesListOld = currentDevicesListOld
        var currentDevicesList = []
        for (let dev in this.currentDevices) {
          currentDevicesList.push(this.currentDevices[dev].name + ' | ' + dev)
        }
        clLog.currentDevicesListNew = currentDevicesList
        if (this.campaignsAddOn === true) {
          var campaignsListOld = []
          for (let oldCampaign in this.clusterCampaignsOld) {
            var ca = this.clusterCampaignsOld[oldCampaign]
            campaignsListOld.push(ca.name + ' | ' + ca.type + ' | ' + ca.startDate + ' - ' + ca.endDate + ' | ' + ca.startTime + ' - ' + ca.endTime)
          }
          clLog.campaignsListOld = campaignsListOld
          var campaignsList = []
          for (let campaign in this.clusterCampaigns) {
            var c = this.clusterCampaigns[campaign]
            campaignsList.push(c.name + ' | ' + c.type + ' | ' + c.startDate + ' - ' + c.endDate + ' | ' + c.startTime + ' - ' + c.endTime)
          }
          clLog.campaignsListNew = campaignsList
          this.globalLogger(campaignsList, 'listtt')
        }
        this.$analytics.logEvent('edit_cluster', clLog)
        // - logiranje kraj
        this.loadingComponent = this.$buefy.loading.open()
        let editClusterRef = null
        if (!this.getNotMigrated().includes(this.userId)) {
          editClusterRef = this.$store.state.database.ref('/neoslide/clusters/' + this.workspaceId + '/' + this.editStaticClusterRef['id'])
        } else {
          editClusterRef = this.$store.state.database.ref('/clusters/' + this.userId + '/' + this.editStaticClusterRef['id'])
        }

        editClusterRef.update({
          name: this.name,
          mainPlaylistId: this.mainPlaylistId || '',
          movingText: this.bHasMovingText ? this.movingText : '',
          menuId: this.bHasMenu ? this.menuId : '',
          specialOffersMenuId: this.bHasSpecialOffer ? this.specialOffersMenuId : '',
          customerSatisfaction: this.bHasCustomerSatisfaction,
          documents: this.bHasDocuments,
          questionnaireId: this.bHasQuestionnaires ? this.questionnaireId : '',
          appMenuEnabled: this.bHasAppMenu
        }, () => {
          this.closeModal()
          this.loadingComponent.close()
        })

        if (!this.getNotMigrated().includes(this.userId)) {
          for (let device in this.availableDevices) {
            this.$store.state.database.ref('/neoslide/devices/' + this.workspaceId + '/' + device).update({
              clusterId: ''
            })
          }
        } else {
          for (let device in this.availableDevices) {
            this.$store.state.database.ref('/devices/' + this.userId + '/' + device).update({
              clusterId: ''
            })
          }
        }

        if (!this.getNotMigrated().includes(this.userId)) {
          for (let device in this.currentDevices) {
            this.$store.state.database.ref('/neoslide/devices/' + this.workspaceId + '/' + device).update({
              clusterId: this.propId
            })
          }
        } else {
          for (let device in this.currentDevices) {
            this.$store.state.database.ref('/devices/' + this.userId + '/' + device).update({
              clusterId: this.propId
            })
          }
        }

        if (this.campaignsAddOn) {
          if (this.campaignsToDelete.length > 0) {
            if (!this.getNotMigrated().includes(this.userId)) {
              for (let i = 0; i < this.campaignsToDelete.length; i++) {
                this.$store.state.database.ref('/neoslide/campaigns/' + this.workspaceId + '/' + this.propId + '/' + this.campaignsToDelete[i]).remove()
              }
            } else {
              for (let i = 0; i < this.campaignsToDelete.length; i++) {
                this.$store.state.database.ref('/campaigns/' + this.userId + '/' + this.propId + '/' + this.campaignsToDelete[i]).remove()
              }
            }
          }

          if (this.campaignsToEdit.length > 0) {
            this.globalLogger('campaigns to edit > 0')
            if (!this.getNotMigrated().includes(this.userId)) {
              for (let y = 0; y < this.campaignsToEdit.length; y++) {
                this.globalLogger(this.campaignsToEdit)
                this.$store.state.database.ref('/neoslide/campaigns/' + this.workspaceId + '/' + this.propId + '/' + this.campaignsToEdit[y].id).update({
                  name: this.campaignsToEdit[y].name,
                  playlistId: this.campaignsToEdit[y].playlistId,
                  type: this.campaignsToEdit[y].type,
                  startTime: this.campaignsToEdit[y].startTime,
                  endTime: this.campaignsToEdit[y].endTime,
                  startDate: this.campaignsToEdit[y].startDate,
                  endDate: this.campaignsToEdit[y].endDate
                })
              }
            } else {
              for (let y = 0; y < this.campaignsToEdit.length; y++) {
                this.globalLogger(this.campaignsToEdit)
                this.$store.state.database.ref('/campaigns/' + this.userId + '/' + this.propId + '/' + this.campaignsToEdit[y].id).update({
                  name: this.campaignsToEdit[y].name,
                  playlistId: this.campaignsToEdit[y].playlistId,
                  type: this.campaignsToEdit[y].type,
                  startTime: this.campaignsToEdit[y].startTime,
                  endTime: this.campaignsToEdit[y].endTime,
                  startDate: this.campaignsToEdit[y].startDate,
                  endDate: this.campaignsToEdit[y].endDate
                })
              }
            }
          }

          if (this.newCampaigns.length > 0) {
            this.globalLogger(this.newCampaigns, 'NOVI ')
            if (!this.getNotMigrated().includes(this.userId)) {
              for (let j = 0; j < this.newCampaigns.length; j++) {
                let newCampaignRef = this.$store.state.database.ref('/neoslide/campaigns/' + this.workspaceId + '/' + this.propId).push()
                let campKey = newCampaignRef.key
                newCampaignRef.set({
                  name: this.newCampaigns[j].name,
                  playlistId: this.newCampaigns[j].playlistId,
                  type: this.newCampaigns[j].type,
                  startTime: this.newCampaigns[j].startTime,
                  endTime: this.newCampaigns[j].endTime,
                  startDate: this.newCampaigns[j].startDate,
                  endDate: this.newCampaigns[j].endDate,
                  id: campKey
                }, () => {
                  this.globalLogger('done')
                })
              }
            } else {
              for (let j = 0; j < this.newCampaigns.length; j++) {
                let newCampaignRef = this.$store.state.database.ref('/campaigns/' + this.userId + '/' + this.propId).push()
                let campKey = newCampaignRef.key
                newCampaignRef.set({
                  name: this.newCampaigns[j].name,
                  playlistId: this.newCampaigns[j].playlistId,
                  type: this.newCampaigns[j].type,
                  startTime: this.newCampaigns[j].startTime,
                  endTime: this.newCampaigns[j].endTime,
                  startDate: this.newCampaigns[j].startDate,
                  endDate: this.newCampaigns[j].endDate,
                  id: campKey
                }, () => {
                  this.globalLogger('done')
                })
              }
            }
          }
        }
      }
    },
    addDeviceToCurrent (id, device) {
      this.availableDevices[id] = undefined
      this.availableDevices = JSON.parse(JSON.stringify(this.availableDevices))
      this.currentDevices[id] = device
    },
    removeDeviceFromCurrent (id, device) {
      this.currentDevices[id] = undefined
      this.currentDevices = JSON.parse(JSON.stringify(this.currentDevices))
      this.availableDevices[id] = device
    },
    devicesLength (devicesList) {
      return Object.keys(devicesList).length > 4
    },
    confirmRemoveCampaign (campId, campName, campInd) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure that you want to <b>delete</b> campaign "' + campName + '"?',
        confirmText: 'Yes',
        type: 'is-danger',
        onConfirm: () => {
          if (campId !== undefined) {
            this.campaignsToDelete.push(campId)
            this.clusterCampaigns = this.clusterCampaigns.filter(x => x.id !== campId)
            // this.newCampaigns = this.newCampaigns.filter(x => x.id !== campId)
            this.campaignsToEdit = this.campaignsToEdit.filter(x => x.id !== campId)
          } else {
            this.globalLogger('campid e undefineddd', this.newCampaigns)
            this.globalLogger('new campaings length', this.newCampaigns.length)
            if (this.newCampaigns.length > 0) {
              var ind = null
              for (let i = 0; i < this.newCampaigns.length; i++) {
                if (this.newCampaigns[i] === this.clusterCampaigns[campInd]) {
                  ind = i
                  this.globalLogger('i: ', i)
                  break
                }
              }
              this.newCampaigns.splice(ind, 1)
            }
            this.clusterCampaigns.splice(campInd, 1)
          }
        }
      })
    },
    addCampaignModal () {
      this.$buefy.modal.open({
        parent: this,
        component: CampaignAddEdit,
        props: { propParentFn: this.receiveCampaignFromChild, isEdit: false },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    receiveCampaignFromChild (item) {
      this.clusterCampaigns.push(item)
      this.newCampaigns.push(item)
      this.globalLogger('receive campaign', this.clusterCampaigns)
      this.globalLogger('receive campaign new campaigns', this.newCampaigns)
    },
    editCampaignModal (ind, id) {
      // let clCampaign = this.clusterCampaigns.filter(x => x.id === id)
      let clCampaign = this.clusterCampaigns[ind]
      this.$buefy.modal.open({
        parent: this,
        component: CampaignAddEdit,
        props: { propParentFn: this.updateCampaignFromChild, isEdit: true, campToEdit: clCampaign, editCampaignId: id, editCampaignIndex: ind },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    updateCampaignFromChild (item, id, indx) {
      this.globalLogger('id i index')
      this.globalLogger(id, indx)
      if (id !== undefined) {
        this.globalLogger(' id ne e indefined')
        item.id = id
        this.campaignsToEdit.push(item)
        for (let z = 0; z < this.clusterCampaigns.length; z++) {
          if (this.clusterCampaigns[z].id === id) {
            this.clusterCampaigns[z] = item
          }
        }
      } else {
        this.globalLogger(' id e undefined')
        if (this.newCampaigns.length > 0) {
          var ind = null
          for (let i = 0; i < this.newCampaigns.length; i++) {
            if (this.newCampaigns[i] === this.clusterCampaigns[indx]) {
              ind = i
              this.globalLogger('i: ', i)
              break
            }
          }
          this.globalLogger(this.newCampaigns, this.newCampaigns[ind])
          this.newCampaigns[ind] = item
          this.globalLogger(this.newCampaigns, this.newCampaigns[ind])
        }
        this.clusterCampaigns[indx] = item
      }
      // za da se refreshiraat vednas podatocite
      var copyArray = []
      for (let cl in this.clusterCampaigns) {
        copyArray.push({ id: cl, ...this.clusterCampaigns[cl] })
      }
      this.clusterCampaigns = []
      for (let copy in copyArray) {
        this.clusterCampaigns.push({ id: copy, ...copyArray[copy] })
      }
      // end
    },
    getCampaignName (nm) {
      if (nm.length > 14) {
        return nm.substr(0, 14) + '...'
      }
      return nm
    },
    checkOverlap () {
      if (this.clusterCampaigns.length >= 2) {
        for (let i = 0; i < this.clusterCampaigns.length; i++) {
          this.globalLogger('HERE11')
          var type1 = this.clusterCampaigns[i].type
          var startDateArray1 = this.clusterCampaigns[i].startDate.split('.')
          var startD1 = new Date(startDateArray1[2], parseInt(startDateArray1[1]) - 1, startDateArray1[0])
          var endDateArray1 = this.clusterCampaigns[i].endDate.split('.')
          var endD1 = new Date(endDateArray1[2], parseInt(endDateArray1[1]) - 1, endDateArray1[0])
          var startTime1 = new Date(2000, 12, 12, this.clusterCampaigns[i].startTime.split(':')[0], this.clusterCampaigns[i].startTime.split(':')[1], 0)
          var endTime1 = new Date(2000, 12, 12, this.clusterCampaigns[i].endTime.split(':')[0], this.clusterCampaigns[i].endTime.split(':')[1], 0)
          for (let j = 0; j < this.clusterCampaigns.length; j++) {
            var type2 = this.clusterCampaigns[j].type
            var startDateArray2 = this.clusterCampaigns[j].startDate.split('.')
            var startD2 = new Date(startDateArray2[2], parseInt(startDateArray2[1]) - 1, startDateArray2[0])
            var endDateArray2 = this.clusterCampaigns[j].endDate.split('.')
            var endD2 = new Date(endDateArray2[2], parseInt(endDateArray2[1]) - 1, endDateArray2[0])
            var startTime2 = new Date(2000, 12, 12, this.clusterCampaigns[j].startTime.split(':')[0], this.clusterCampaigns[j].startTime.split(':')[1], 0)
            var endTime2 = new Date(2000, 12, 12, this.clusterCampaigns[j].endTime.split(':')[0], this.clusterCampaigns[j].endTime.split(':')[1], 0)
            if (this.clusterCampaigns[i] !== this.clusterCampaigns[j]) {
              if ((startD1 <= startD2 && startD2 <= endD1) || (startD1 <= endD2 && endD2 <= endD1) || (startD2 < startD1 && endD1 < endD2)) {
                this.globalLogger('tuka1')
                if ((startTime1 <= startTime2 && startTime2 <= endTime1) || (startTime1 <= endTime2 && endTime2 <= endTime1) || (startTime2 < startTime1 && endTime1 < endTime2)) {
                  this.globalLogger('tuka2')
                  if ((type1 === 1 && type2 === 1) || (type1 === 2 && type2 === 2) || (type1 === 3 && type2 === 3)) {
                    this.globalLogger('PREKLOPUVANJE')
                    return true
                  } else if (type1 === 1 && type2 === 2) {
                    var startDate1copy = startD1
                    this.globalLogger(startDate1copy, 'copy')
                    while (startDate1copy <= endD1) {
                      this.globalLogger('vo while')
                      const dayOfWeek = startDate1copy.getDay()
                      this.globalLogger(dayOfWeek)
                      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                        this.globalLogger('PREKLOPUVANJE')
                        return true
                      }
                      let incrementedDate = startDate1copy.setDate(startDate1copy.getDate() + 1)
                      startDate1copy = new Date(incrementedDate)
                      // startDate1copy = Date(startDate1copy.getDate())
                      this.globalLogger('COPYY: ', startDate1copy)
                    }
                  } else if (type1 === 1 && type2 === 3) {
                    var startDate1copy2 = startD1
                    this.globalLogger(startDate1copy2, 'copy2')
                    while (startDate1copy2 <= endD1) {
                      this.globalLogger('vo while2')
                      const dayOfWeek2 = startDate1copy2.getDay()
                      this.globalLogger(dayOfWeek2)
                      if (dayOfWeek2 === 0 || dayOfWeek2 === 6) {
                        this.globalLogger('PREKLOPUVANJE')
                        return true
                      }
                      let incrementedDate2 = startDate1copy2.setDate(startDate1copy2.getDate() + 1)
                      startDate1copy2 = new Date(incrementedDate2)
                      // startDate1copy = Date(startDate1copy.getDate())
                      this.globalLogger('COPYY: ', startDate1copy2)
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.globalLogger('FALSE')
      return false
    },
    getPlaylistName (plId) {
      for (let playlist in this.playlists) {
        if (playlist === plId) {
          if (this.playlists[playlist].name.length > 14) {
            return this.playlists[playlist].name.substr(0, 14) + '...'
          }
          return this.playlists[playlist].name
        }
      }
    },
    getType (typ) {
      switch (typ) {
        case 1:
          return 'Every day'
        case 2:
          return 'Weekdays'
        case 3:
          return 'Weekend'
        default:
          break
      }
    },
    closeModal () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
th, td {
  padding: 4px;
}
tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.scrollit {
    overflow:scroll;
    overflow-x: hidden;
    height:150px;
}
.mytable {
  max-height: 215px;
  overflow-y: auto;
}
.topPadding {
  padding-top: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/clusters/ClusterAddEdit.vue